module.exports = __webpack_public_path__ + "static/media/React.4f81f37c.svg";